import { SubscriptionProduct } from '../../models/subscription-product';
import { Product } from '../../models/product';

import { Injectable, OnInit } from '@angular/core';
import { DataService } from '../data-services/data.service';
import { catchError, map, Observable, of } from 'rxjs';
import { IProductGroup } from '../../models/product-group';


@Injectable({
  providedIn: 'root'
})
export class ProductGroupService extends DataService<IProductGroup> implements OnInit {

  protected collectionname = 'product-group';

  ngOnInit(): void {
    this.setCollectionName('product-group');
  }

  getProductGroups(organizationId: string): Observable<IProductGroup[]> {
    const url = `${this.urlService.buildUrl(
      this.collectionname
    )}${organizationId}/list`;

    return this.http.get<IProductGroup[]>(`${url}`).pipe(
      map((res: Array<IProductGroup>) => {
        res.forEach((item) => {
          this.setId(item);
        });
        return res || ({} as Array<IProductGroup>);
      }),
      catchError(this.errorMgmt)
    );
  }

  assignGroupBulk(productIds: string[], groupId: string) {
    const url = `${this.urlService.baseUri}/product-group/assign-bulk`;
    return this.http.post(url, { productIds, groupId });
  }


}
